import React, { FC, useState } from 'react';
import { NavLink } from 'react-router';
import cx from 'classnames';

import { url } from 'helpers';
import { useLang } from 'hooks';
import { Cross, Menu as Burger } from 'components/icons';
import { Breadcrumbs, Layout } from 'components/layout';
import { Button, Container, Drawer, Menu } from 'components/ui';
import { MenuProps } from 'types/components';
import { BaseLayoutProps } from 'types/layouts';

import BaseLayout from '../BaseLayout';

import styles from './styles.module.css';

import Balance from './Balance';
import LogoutButton from './LogoutButton';
import InvoiceButton from './InvoiceButton';

type DashboardLayoutProps = BaseLayoutProps & {
  headerClassName?: string;
  contentClassName?: string;
};

const DashboardLayout: FC<DashboardLayoutProps> = ({
  headerClassName,
  contentClassName,
  children,
  ...props
}) => {
  const lang = useLang();

  const [open, setOpen] = useState(false);

  const showDrawer = () => setOpen(true);

  const hideDrawer = () => setOpen(false);

  const menuItems: MenuProps['items'] = [
    {
      key: 'dashboard',
      label: <NavLink to={url.toDashboard()} end>{lang.get('common.menu.dashboard')}</NavLink>,
    }, {
      key: 'invoices',
      label: <NavLink to={url.toInvoices()} end>{lang.get('common.menu.invoices')}</NavLink>,
    }, {
      key: 'profile',
      label: <NavLink to={url.toProfile()} end>{lang.get('common.menu.profile')}</NavLink>,
    }, {
      key: 'withdrawal',
      label: <NavLink to={url.toWithdrawal()} end>{lang.get('common.menu.withdrawal')}</NavLink>,
    },
  ];

  return (
    <BaseLayout {...props}>
      <Layout>

        <Layout.Header
          className={cx(styles.header, headerClassName)}
          contentClassName={styles.header__content}
        >
          <Menu
            className={styles.header__menu}
            rootClassName={styles.header__menu}
            items={menuItems}
            mode="horizontal"
          />
          <Balance className={styles.header__balance} />
          <InvoiceButton className={styles.header__invoice} />
          <LogoutButton className={styles.header__logout} />
          <Button
            className={styles.header__toggle}
            type="default"
            icon={open ? <Cross /> : <Burger />}
            onClick={open ? hideDrawer : showDrawer}
          />
        </Layout.Header>

        <Layout.Content className={cx(styles.content, contentClassName)}>
          <Breadcrumbs />
          {children}
        </Layout.Content>

        <Drawer
          rootClassName={styles.drawer}
          placement="top"
          closeIcon={false}
          open={open}
          onClose={hideDrawer}
        >
          <Container>
            <Menu
              className={styles.drawer__menu}
              items={menuItems}
              mode="inline"
            />
            <div className={styles.drawer__footer}>
              <InvoiceButton className={styles.drawer__invoice} block />
              <LogoutButton className={styles.drawer__logout} />
            </div>
          </Container>
        </Drawer>

      </Layout>
    </BaseLayout>
  );
};

export default DashboardLayout;
